<template>
	<CDialog
		:visible="show"
		:title="isInBuilder ? 'Congratulations on creating your first guest list!' : 'Congratulations on connecting your first guest list!'"
		max-width="800px"
		data-testid="guest-access-welcome-dialog"
		@close="$emit('close')"
		@closed="$emit('closed')"
	>
		<div class="flex gap-4 items-start">
			<div class="b5:w-66">
				<p class="mb-4 mt-5 text-3">The people on this list can now log in to your organization as guests.</p>
				<p class="mb-4 text-3"><strong>What's next?</strong> Use a Person field to connect your guest list to other forms. Set up workflows that allow guests to view and update their entries, submit new forms, and complete tasks in one place. You can also automatically populate guest details like names, emails, photos, and more. </p>
				<p class="text-3"><a target="_blank" rel="noopener" href="/support/504/workflow/guest-access/adding-guests#creating-guest-lists">Check out our tutorials</a> for step-by-step instructions.</p>
			</div>

			<Inline class="b5:show b5:w-33" :svg="personSubmissions ? 'complex-icons/guest-access' : 'complex-icons/person-field'" />
		</div>
		<template #footer>
			<CButton class="button--primary" @click="$emit('close')">Close</CButton>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { computed, defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CButton from 'src/components/interaction/Button.vue';
	import session from '@cognitoforms/api/services/session';

	export default defineComponent({
		name: 'CLookupFieldWelcomeDialog',
		components: {
			CDialog,
			CButton
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			isInBuilder: {
				type: Boolean,
				default: false
			}
		},
		emits: ['close', 'closed'],
		setup() {
			const personSubmissions = computed(() => session.value?.enabledFeatures?.PersonSubmissions ?? false);
			return { personSubmissions };
		}
	});
</script>